import React from 'react';
import LoaderStyles from './Loader.style';

const Loader = (props) => (
    <LoaderStyles>
        <div className='WRAP_LOADER' style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        }}>
            <div className="lds-ellipsis" style={{ height: props.size + 'px' }}>
                <div style={{ backgroundColor: props.color, width: props.size, height: props.size }}></div>
                <div style={{ backgroundColor: props.color, width: props.size, height: props.size }}></div>
                <div style={{ backgroundColor: props.color, width: props.size, height: props.size }}></div>
                <div style={{ backgroundColor: props.color, width: props.size, height: props.size }}></div>
            </div>
        </div>
    </LoaderStyles>
);

export default Loader;
